import ptime from 'promise-timeout';

const timeoutSecs = 30;

const timeout = async (func) => ptime.timeout(func, timeoutSecs * 1000);

export default timeout;
